module.exports = __webpack_public_path__ + "static/media/steiger.0dcb8629.png";